import React from "react";
import BaseLayout from "layouts/base-layout";
import Link from "helpers/link";
import RichText from "components/rich-text";
import { formatTitle } from "helpers/format-title";
import Button from "components/button";
import Image from "components/image";

const NotFound = ({ pageContext: { header, collections, title, subtitle, recommendedText, button }, location }) => (
	<BaseLayout header={header} path={location.pathname}>
		<div className="flex justify-center w-full min-h-[70vh] items-center mt-10 md:mt-20">
			<div className="flex flex-col gap-5 text-center">
				<h1>{formatTitle(title)}</h1>
				<div className="flex flex-col gap-5 w-fit mx-auto justify-center">
					<p>{subtitle}</p>
					<Button data={button} className="px-2 md:px-8" />
				</div>
				<div className="my-20">
					<h2 className="flex gap-5 mx-auto justify-center">{recommendedText}</h2>
					{collections?.length > 0 && collections.map((data) => (
						<div key={data?.handle} className="hd-screen-max-width flex flex-col items-center w-full mx-auto my-6">
							<div className="m-auto text-center w-full md:w-1/2 mb-12">
								<RichText value={data?.content} />
							</div>
							<div className="flex flex-wrap justify-center">
								{data?.products?.map((item, index) => (
									<div id={item?.id} key={`${item?.id}${index}`} className="w-[48%] mx-[1%] md:w-[30%] lg:w-[22%] mb-10 lg:mx-2">
										{item?._type === "media" ? (
											<Image image={item} to={item?.url} key={index}/>
										) : (
											<div>
												<Link to={`/products/${item?.handle}`} className="cursor-pointer">
													<img src={item?.image} alt={item?.title} className="w-full" />
												</Link>
												<Link to={`/products/${item?.handle}`} className="cursor-pointer">
													<div className="text-center pt-2 font-body hover:underline cursor-pointer md:pt-3">{item?.title}</div>
												</Link>
												<div className="text-center mt-2.5 mb-3.5 mx-auto font-base text-secondary text-sm">
													{item?.shortDescription}
												</div>
											</div>)}
									</div>
								))}
							</div>
						</div>
					))}
				</div>
			</div>
		</div>
	</BaseLayout>
);

export default NotFound;
